module.exports = __webpack_public_path__ + "img/login.c8992ee6.png";